import { SET_COMPANY_INFO_LIST, CompanyInfoActionTypes, CompanyInfo } from "../types/companies";

export function setCompanyInfoList(payload: CompanyInfo[]): CompanyInfoActionTypes {
  return {
    type: SET_COMPANY_INFO_LIST,
    payload,
  };
}
